import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { AppLoad } from "../../../core/AppLoad";
import { useHistory, Link } from "react-router-dom";
import { AppStateContext, AppConfig } from "../../../app-state";
import { Icon } from "../../../core/Icon";
import { NavbarBackHome } from "../../common/header-and-footer/NavbarBackHome";
export const RegisterType = (props) => {
    const { state, dispatch } = useContext(AppStateContext);
    const [isLoading, updateLoading] = useState(false);
    const [loginResponse, updateLoginResponse] = useState(null);
    const { register, handleSubmit, errors, setValue } = useForm();
    let history = useHistory();
    const onSubmit = (data) => {
        updateLoading(true);
        AppLoad(AppConfig.APIUrl + 'public/auth/login', data).then((Response) => {
            if (Response.status == 'invalid') {
                if (Response.unsuccessful_tries > 5) {
                    updateLoginResponse('locked');
                }
                else {
                    updateLoginResponse('invalid');
                }
                setValue("password", "");
            }
            else if (Response.status == 'ok') {
                dispatch({ type: 'authCheckLogged', payload: Response.userData });
                history.push('/cs/seznam/nejblizsi-aukce');
            }
            updateLoading(false);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NavbarBackHome, null),
        React.createElement("div", { className: "process-master-form" },
            React.createElement("div", { className: "register-challenge" },
                React.createElement("h1", null, "Registrace do syst\u00E9mu elektronick\u00FDch aukc\u00ED"),
                React.createElement(Link, { className: "block-button forward", to: "/cs/proces/registrace/fyzicka-osoba" },
                    "Fyzick\u00E1 osoba",
                    React.createElement(Icon, { c: ['chevron-right', 12, 12] })),
                React.createElement(Link, { className: "block-button forward", to: "/cs/proces/registrace/pravnicka-osoba" },
                    "Pr\u00E1vnick\u00E1 osoba",
                    React.createElement(Icon, { c: ['chevron-right', 12, 12] })),
                React.createElement(Link, { className: "block-button forward", to: "/cs/proces/registrace/trust" },
                    "V\u00EDce \u00FA\u010Dastn\u00EDk\u016F",
                    React.createElement(Icon, { c: ['chevron-right', 12, 12] })),
                React.createElement("div", { className: "utils" },
                    "U\u017E m\u00E1te \u00FA\u010Det? M\u016F\u017Eete se ",
                    React.createElement(Link, { className: "hyperlink", to: "/cs/proces/prihlaseni-uzivatele" }, "p\u0159ihl\u00E1sit"),
                    ".")))));
};
